export const PaymentColumns = [
  // { key: 'select', label: '', sortable: false, isCheckbox: true, sticky: true }, // for checkboxes
  // { key: 'id', label: 'S No', sortable: true, sticky: true },
  {
    key: 'transferDate',
    label: 'Trans. Date',
    sortable: true,
    sticky: false,
  },
  { key: 'availableOn', label: 'Import Date', sortable: true, sticky: false },
  { key: 'client', label: 'Client', sortable: true, sticky: false },
  { key: 'taskId', label: 'Task ID', sortable: true, sticky: false },
  {
    key: 'invoiceNo',
    label: 'Invoice No',
    sortable: true,
    sticky: false,
  },
  {
    key: 'transactionId',
    label: 'Trans. Id',
    sortable: true,
    sticky: false,
  },
  { key: 'amount', label: 'Amount', sortable: true, sticky: false },

  {
    key: 'status',
    label: 'Status',
    sortable: true,
    sticky: false,
  },
  { key: 'logs', label: 'Logs', sortable: false, sticky: false }, // for buttons like Save, Edit, Delete
];

export const TransferColumns = [
  // { key: 'select', label: '', sortable: false, isCheckbox: true, sticky: true }, // for checkboxes
  // { key: 'id', label: 'S No', sortable: true, sticky: true },
  {
    key: 'transferDate',
    label: 'Trans. Date',
    sortable: true,
    sticky: false,
  },
  { key: 'availableOn', label: 'Import Date', sortable: true, sticky: false },
  {
    key: 'serviceProvider',
    label: 'Service Provider',
    sortable: true,
    sticky: false,
  },
  { key: 'taskId', label: 'Task ID', sortable: true, sticky: false },
  {
    key: 'invoiceNo',
    label: 'Invoice No',
    sortable: true,
    sticky: false,
  },
  { key: 'amount', label: 'Amount', sortable: true, sticky: false },
  {
    key: 'transactionId',
    label: 'Trans. Id',
    sortable: true,
    sticky: false,
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    sticky: false,
  },

  { key: 'logs', label: 'Logs', sortable: false, sticky: false }, // for buttons like Save, Edit, Delete
];

export const PayoutColumns = [
  // { key: 'select', label: '', sortable: false, isCheckbox: true, sticky: true }, // for checkboxes
  // { key: 'id', label: 'S No', sortable: true, sticky: true },
  {
    key: 'transferDate',
    label: 'Trans. Date',
    sortable: true,
    sticky: false,
  },
  { key: 'availableOn', label: 'Imported Date', sortable: true, sticky: false },
  { key: 'totalAmount', label: 'Amount', sortable: true, sticky: false },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    sticky: false,
  },
  { key: 'logs', label: 'Logs', sortable: false, sticky: false }, // for buttons like Save, Edit, Delete
];

export const StripeFeeColumns = [
  // { key: 'select', label: '', sortable: false, isCheckbox: true, sticky: true }, // for checkboxes
  // { key: 'id', label: 'S No', sortable: true, sticky: true },
  {
    key: 'createdDate',
    label: 'Created Date',
    sortable: true,
    sticky: false,
  },
  {
    key: 'modifiedDate',
    label: 'Modified Date',
    sortable: true,
    sticky: false,
  },
  { key: 'totalAmount', label: 'Amount', sortable: true, sticky: false },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    sticky: false,
  },
  { key: 'logs', label: 'Logs', sortable: false, sticky: false }, // for buttons like Save, Edit, Delete
];

export const AllTransactionsColumns = [
  // { key: 'select', label: '', sortable: false, isCheckbox: true, sticky: true }, // for checkboxes
  // { key: 'id', label: 'S No', sortable: true, sticky: true },
  {
    key: 'transferDate',
    label: 'Trans. Date',
    sortable: true,
    sticky: false,
  },
  { key: 'availableOn', label: 'Import Date', sortable: true, sticky: false },
  { key: 'client', label: 'Client', sortable: true, sticky: false },
  {
    key: 'serviceProvider',
    label: 'Service Provider',
    sortable: true,
    sticky: false,
  },

  { key: 'amount', label: 'Amount', sortable: true, sticky: false },
  { key: 'taskId', label: 'Task ID', sortable: true, sticky: false },
  {
    key: 'invoiceNo',
    label: 'Invoice No',
    sortable: true,
    sticky: false,
  },
  {
    key: 'transactionType',
    label: 'Trans. Type',
    sortable: true,
    sticky: false,
  },
  {
    key: 'transactionId',
    label: 'Trans. Id',
    sortable: true,
    sticky: false,
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    sticky: false,
  },

  { key: 'logs', label: 'Logs', sortable: false, sticky: false }, // for buttons like Save, Edit, Delete
];

export const StripeDataColumns = [
  {
    key: 'id',
    label: 'ID',
    sortable: true,
    sticky: false,
  },
  {
    key: 'stripeId',
    label: 'Stripe ID',
    sortable: true,
    sticky: false,
  },
  {
    key: 'paymentType',
    label: 'Payment Type',
    sortable: true,
    sticky: false,
  },
  {
    key: 'paymentSource',
    label: 'Payment Source',
    sortable: true,
    sticky: false,
  },
  {
    key: 'amount',
    label: 'Amount',
    sortable: true,
    sticky: false,
  },
  {
    key: 'currency',
    label: 'Currency',
    sortable: true,
    sticky: false,
  },
  {
    key: 'createdOn',
    label: 'Created On',
    sortable: true,
    sticky: false,
  },
  {
    key: 'availableOn',
    label: 'Available On',
    sortable: true,
    sticky: false,
  },
  {
    key: 'description',
    label: 'Description',
    sortable: true,
    sticky: false,
  },
  {
    key: 'remarks',
    label: 'Remarks',
    sortable: true,
    sticky: false,
  },
  {
    key: 'remarks2',
    label: 'Remarks 2',
    sortable: true,
    sticky: false,
  },
  {
    key: 'transferDate',
    label: 'Transfer Date',
    sortable: true,
    sticky: false,
  },
  {
    key: 'transferGroup',
    label: 'Transfer Group',
    sortable: true,
    sticky: false,
  },
  {
    key: 'taskId',
    label: 'Task ID',
    sortable: true,
    sticky: false,
  },
  {
    key: 'journal',
    label: 'Journal',
    sortable: true,
    sticky: false,
  },
  {
    key: 'ledger',
    label: 'Ledger',
    sortable: true,
    sticky: false,
  },
  {
    key: 'shopperEmail',
    label: 'Shopper Email',
    sortable: true,
    sticky: false,
  },
  {
    key: 'paymentDpt',
    label: 'Payment Department',
    sortable: true,
    sticky: false,
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    sticky: false,
  },
  {
    key: 'createdBy',
    label: 'Created By',
    sortable: true,
    sticky: false,
  },
  {
    key: 'createdDate',
    label: 'Created Date',
    sortable: true,
    sticky: false,
  },
  {
    key: 'modifiedDate',
    label: 'Modified Date',
    sortable: true,
    sticky: false,
  },
  {
    key: 'importCounter',
    label: 'Import Counter',
    sortable: true,
    sticky: false,
  },
];

export const columnCOnfig = [
  {
    key: 'id',
    label: 'Id',
    sortable: true,
    sticky: false,
  },
  {
    key: 'transactionId',
    label: 'Transaction Id',
    sortable: true,
    sticky: false,
  },
  {
    key: 'transactionType',
    label: 'Transaction Type',
    sortable: true,
    sticky: false,
  },
  {
    key: 'paymentSource',
    label: 'Payment Source',
    sortable: true,
    sticky: false,
  },
  {
    key: 'amount',
    label: 'Amount',
    sortable: true,
    sticky: false,
  },
  {
    key: 'currency',
    label: 'Currency',
    sortable: true,
    sticky: false,
  },
  {
    key: 'createdOn',
    label: 'Created On',
    sortable: true,
    sticky: false,
  },
  {
    key: 'availableOn',
    label: 'Available On',
    sortable: true,
    sticky: false,
  },
  {
    key: 'availableOn',
    label: 'Available On',
    sortable: true,
    sticky: false,
  },
  // "description": "PAYMENT DONE",
  // "remarks": "pm_1QehVaJZZMNTppNSOZ3KSBXn",
  // "remarks2": "pi_3QehVAJZZMNTppNS0QoxnyeQ",
  // "transferDate": "07-01-2025",
  // "invoiceNo": "TG.98536.164035",
  // "taskId": 164035,
  // "journal": 200,
  // "ledger": "1500",
  // "shopperEmail": "rrensma@ziggo.nl",
  // "paymentDpt": "98536",
  // "status": "Not found",
  // "createdby": "madhu",
  // "createddate": "23-05-2025",
  // "modifieddate": "23-05-2025",
  // "importCounter": 0,
  // "client": null,
  // "serviceProvider": null
];

export const stripeColumns = [
  // {
  //   key: 'id',
  //   label: 'Id',
  //   sortable: true,
  //   sticky: false,
  // },
  {
    key: 'creationDate',
    label: 'Creation Date',
    sortable: true,
    sticky: false,
  },
  {
    key: 'name',
    label: 'Name',
    sortable: true,
    sticky: false,
  },
  // {
  //   key: 'type',
  //   label: 'Type',
  //   sortable: true,
  //   sticky: false,
  // },
  // {
  //   key: 'taskId',
  //   label: 'Task Id',
  //   sortable: true,
  //   sticky: false,
  // },
  {
    key: 'profileId',
    label: 'Profile Id',
    sortable: true,
    sticky: false,
  },
  // {
  //   key: 'financeMutationId',
  //   label: 'Finance Mutation Id',
  //   sortable: true,
  //   sticky: false,
  // },
  // {
  //   key: 'stripeTransactionId',
  //   label: 'Stripe Trans. Id',
  //   sortable: true,
  //   sticky: false,
  // },
  {
    key: 'description',
    label: 'Description',
    sortable: true,
    sticky: false,
  },

  // {
  //   key: "stripeTransactionStringId",
  //   label: "Stripe Trans. Str. Id",
  //   sortable: true,
  //   sticky: false,
  // },
  //   {

  //     "id": 806,
  //     "creationDate": "2025-04-08T21:02:52.563",
  //     "type": 817,
  //     "taskId": 112540,
  //     "profileId": 109604,
  //     "financeMutationId": 0,
  //     "stripeTransactionId": 1,
  //     "description": "Stripe data export failed and EOL invoiceNumber ()",
  //     "name": "madhu",
  //     "stripeTransactionStringId": ""
  // }
];
